import React, { useEffect, useState } from "react";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import {
    Table, TableHead, TableBody, TableRow, TableCell, TableContainer, Paper,
    Select, MenuItem, FormControl, InputLabel, Box,
    Button,
    Pagination
} from "@mui/material";
import { formatPhoneNumber } from '../../../common/helpers/commonFun';
import PolicyInfo from "../PolicyDetails/PolicyInfo";
import { getPolicyListingAction } from "../../../redux/actions/customerDetailsAction";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { getDetailPolicyAction } from "../../../redux/actions/policyActions";


const CustomerPolicyListing = ({
    id,
    selected_customer_list = [],
    policyRowsPerPage = 10,
    handlePolicyChangePage,
    handlePolicyChangeRowsPerPage,
    policyPage = 0,
    customer_policy_pagination = { totalElements: 0 },
    client_Customer_Id
}) => {
    const location = useLocation();
    const { clientCustomerId } = location.state || {};
    const dispatch = useDispatch();
    const [selectedPolicyId, setSelectedPolicyId] = useState("");
    const [showDetails, setShowDetails] = useState(false);

    const customer_policy_listing = useSelector((state) =>
        state.customerDetails?.policy_listing || []
    );

    const handlePolicyRowClick = (rowData) => {
        if (!rowData || !rowData.id) {
            console.error('Invalid row data:', rowData);
            return;
        }

        setSelectedPolicyId(rowData.id);
        setShowDetails(true);
        const customerId = client_Customer_Id || clientCustomerId;
        if (customerId) {
            dispatch(getPolicyListingAction(customerId));
        }
        // dispatch(getDetailPolicyAction(rowData.id));
    };

    useEffect(() => {
        if (clientCustomerId) {
            dispatch(getPolicyListingAction(clientCustomerId));
        }
    }, [clientCustomerId, dispatch]);
    useEffect(() => {
        if (id) {
            setSelectedPolicyId(id);
            setShowDetails(true);
            dispatch(getDetailPolicyAction(id));
        }
    }, [id]);

    const handleDropdownChange = (event) => {
        const selectedId = event.target.value;
        if (selectedId) {
            setSelectedPolicyId(selectedId);
            setShowDetails(true);
        }
    };

    const handleBackToListing = () => {
        setSelectedPolicyId("");
        setShowDetails(false);
    };

    if (!handlePolicyChangePage || !handlePolicyChangeRowsPerPage) {
        console.warn('Missing required pagination handlers');
    }

    return (
        <Box sx={{ padding: '0 20px' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                {selectedPolicyId && showDetails && (
                    <Button color="primary" onClick={handleBackToListing}>
                        <ArrowBackIosIcon />
                        Back to Listing
                    </Button>
                )}
                <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                    {showDetails && customer_policy_listing.length > 0 && (
                        <FormControl fullWidth sx={{ mb: 2, width: '250px' }}>
                            <InputLabel>Select Policy</InputLabel>
                            <Select
                                value={selectedPolicyId}
                                onChange={handleDropdownChange}
                                label="Select Policy"
                            >
                                {customer_policy_listing.map((policy) => (
                                    <MenuItem key={policy.id} value={policy.id}>
                                        {policy.policyNumber || `Policy ${policy.id}`}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    )}
                </Box>
            </Box>

            {showDetails && selectedPolicyId ? (
                <PolicyInfo policyId={selectedPolicyId} />
            ) : (
                <>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell className="styled-table-heading">Name</TableCell>
                                    <TableCell className="styled-table-heading">Policy Number</TableCell>
                                    <TableCell className="styled-table-heading">Phone Number</TableCell>
                                    <TableCell className="styled-table-heading">Policy Type</TableCell>
                                    <TableCell className="styled-table-heading">Eff Date</TableCell>
                                    <TableCell className="styled-table-heading">Exp Date</TableCell>
                                    <TableCell className="styled-table-heading">Status</TableCell>
                                    <TableCell className="styled-table-heading">Premium</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {!selected_customer_list || selected_customer_list.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={8} align="center">
                                            No policies exist
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    selected_customer_list.map((row) => (
                                        <TableRow
                                            key={row.id}
                                            onClick={() => handlePolicyRowClick(row)}
                                            style={{ cursor: "pointer" }}
                                            hover
                                        >
                                            <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>
                                                {`${row.firstName || ''} ${row.lastName || ''}`.trim() || 'N/A'}
                                            </TableCell>
                                            <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>{row.policyNumber || 'N/A'}</TableCell>
                                            <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>
                                                {row.phoneNumber ? formatPhoneNumber(row.phoneNumber) : 'N/A'}
                                            </TableCell>
                                            <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>{row.policyType || 'N/A'}</TableCell>
                                            <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>{row.effectiveDate || 'N/A'}</TableCell>
                                            <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>{row.expirationDate || 'N/A'}</TableCell>
                                            <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>{row.status || 'N/A'}</TableCell>
                                            <TableCell sx={{fontFamily: `"Poppins", sans-serif`,}}>{row.premium || 'N/A'}</TableCell>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    {customer_policy_pagination.totalElements > 0 && handlePolicyChangePage && handlePolicyChangeRowsPerPage && (
                        <Box
                            display="flex"
                            justifyContent="flex-end"
                            alignItems="center"
                            mt={2}
                            px={2}
                        >
                            <span style={{ marginRight: 8, fontSize: '14px' }}>Rows per page:</span>
                            <FormControl size="small" sx={{ minWidth: 80, mr: 2 }}>
                                <Select
                                    value={policyRowsPerPage}
                                    onChange={handlePolicyChangeRowsPerPage}
                                >
                                    {[5, 10, 15, 25, 50, 100].map((option) => (
                                        <MenuItem key={option} value={option}>
                                            {option}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <Pagination
                                count={Math.ceil(customer_policy_pagination.totalElements / policyRowsPerPage)}
                                page={policyPage + 1}
                                onChange={(e, newPage) => handlePolicyChangePage(e, newPage - 1)}
                                />
                        </Box>
                    )}
                </>
            )}
        </Box>
    );
};

export default CustomerPolicyListing;